// Copyright (c) 2019 Comsearch, Inc., All rights reserved

const addPathNumberToHeadings = (newPathValidations, projectPaths) => {
  // if there are paths stored in the projectSummary redux state, then that means
  // we're in that subtree. We wanna add the path #s now!
  // (path number is determined in the UI when it loads up the project data.)
  // (and it's only relevant when talking about paths within the context of a project)

  // loops over projectSummary.paths to determine if these paths are in the
  projectPaths.forEach(d => {
    const pathId = d.get('pathId')

    const pathsValidations = newPathValidations[pathId]

    if (pathsValidations) {
      pathsValidations.heading = `#${d.get('pathIndex')} ${pathsValidations.heading}`
    }
  })
}

export default addPathNumberToHeadings
